import React from 'react';
import './Project.css';
import { useNavigate } from 'react-router-dom';

export interface ProjectProps {
    name: string;
    description: string;
    skills: string[];
    image: string;
    link: string;
    slug: string;
    slides: any[];
}

const Project = (props: ProjectProps) => {

    // send project data to project page
    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/project/' + props.slug + '/', { state: { project: props } });
    };

    return (
        <div className="project-card" onClick={handleClick}>
            <div className="project-image">
                <img src={props.image} alt={props.name} />
                <div className="project-overlay">
                    <div className="project-details">
                        <h3>{props.name}</h3>
                        <p>{props.description}</p>
                        <div className="project-actions">
                            {props.link ? (
                                <a
                                    className="project-link-button"
                                    href={props.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    Visit site
                                </a>
                            ) : null}
                            <button
                                className="project-details-button"
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleClick();
                                }}
                            >
                                View details
                            </button>
                        </div>
                        <ul className="project-skills">
                            {props.skills.map((skill, index) => (
                                <li key={index}>{skill}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Project;